import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SalesReportComponent from './sales-report.component';

let SalesReportModule = angular
  .module('SalesReport', [
    uiRouter
  ])
  .component('salesReport', SalesReportComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('salesReport', {
      url: '/sales-report',
      data: {
        authRequired: true,
        permsRequired: ['sales-report']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'salesReport'
        }
      }
    })
  })
  .name;

export default SalesReportModule;



// WEBPACK FOOTER //
// ./src/app/pages/sales-report/sales-report.module.js